export const VALIDATE_SURL_REQUEST = 'VALIDATE_SURL_REQUEST';
export const VALIDATE_SURL_SUCCESS = 'VALIDATE_SURL_SUCCESS';
export const VALIDATE_SURL_FAILURE = 'VALIDATE_SURL_FAILURE';
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGIN_CODE_REQUIRED = 'LOGIN_CODE_REQUIRED';
export const LOGIN_CODE_REQUEST = 'LOGIN_CODE_REQUEST';
export const LOGIN_CODE_SUCCESS = 'LOGIN_CODE_SUCCESS';
export const LOGIN_CODE_FAILURE = 'LOGIN_CODE_FAILURE';
export const REGISTER_CODE_REQUEST = 'REGISTER_CODE_REQUEST';
export const REGISTER_CODE_SUCCESS = 'REGISTER_CODE_SUCCESS';
export const REGISTER_CODE_FAILURE = 'REGISTER_CODE_FAILURE';
export const LOGIN_CODE_RELOGIN = 'LOGIN_CODE_RELOGIN';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';
export const RETRIEVE_COLLECTIONS_REQUEST = 'RETRIEVE_COLLECTIONS_REQUEST';
export const RETRIEVE_COLLECTIONS_SUCCESS = 'RETRIEVE_COLLECTIONS_SUCCESS';
export const RETRIEVE_COLLECTIONS_FAILURE = 'RETRIEVE_COLLECTIONS_FAILURE';
export const RETRIEVE_ADVANCED_SEARCH_COLLECTIONS_REQUEST = 'RETRIEVE_ADVANCED_SEARCH_COLLECTIONS_REQUEST';
export const RETRIEVE_ADVANCED_SEARCH_COLLECTIONS_SUCCESS = 'RETRIEVE_ADVANCED_SEARCH_COLLECTIONS_SUCCESS';
export const RETRIEVE_ADVANCED_SEARCH_COLLECTIONS_FAILURE = 'RETRIEVE_ADVANCED_SEARCH_COLLECTIONS_FAILURE';
export const RETRIEVE_METATAGS_REQUEST = 'RETRIEVE_METATAGS_REQUEST';
export const RETRIEVE_METATAGS_SUCCESS = 'RETRIEVE_METATAGS_SUCCESS';
export const RETRIEVE_METATAGS_FAILURE = 'RETRIEVE_METATAGS_FAILURE';
export const LOGOUT_COMPLETED = 'LOGOUT_COMPLETED';
export const CHANGE_LOCALE = 'CHANGE_LOCALE';
export const CHANGE_DATA_LANGUAGE = 'CHANGE_DATA_LANGUAGE';
export const UPDATE_DEFAULT_COLLECTION_LABEL = 'UPDATE_DEFAULT_COLLECTION_LABEL';
export const SESSION_EXPIRED = 'SESSION_EXPIRED';
export const VALIDATE_SESSION_CONNECTION_REQUEST = 'VALIDATE_SESSION_CONNECTION_REQUEST';
export const VALIDATE_SESSION_CONNECTION_SUCCESS = 'VALIDATE_SESSION_CONNECTION_SUCCESS';
export const VALIDATE_SESSION_CONNECTION_FAILURE = 'VALIDATE_SESSION_CONNECTION_FAILURE';
export const UPDATE_STORE_FROM_APPCONFIG = 'UPDATE_STORE_FROM_APPCONFIG';
